import {ReactComponent as IconSprite} from '../../../assets/svg-sprites/icon-sprite.svg';

export const CustomSprite = () => {
    return (
        <div style={{display: 'none'}}>
            <IconSprite/>
        </div>
    );
};